import  { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Row, Col, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";

function ExportModal({ show, handleClose, id, exportAll }) {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [exportLoading, setExportLoading] = useState(false);

  const handleExport = async () => {
    setExportLoading(true);
    try {
      let response;

      if (exportAll) {
        response = await axios.get(
          `${BASE_URL}/api/export-all-users-attendance/`,
          {
            params: {
              start_date: startDate.toISOString().split("T")[0],
              end_date: endDate.toISOString().split("T")[0],
            },
            responseType: "blob",
            headers: {
              ...HEADERS,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
        response = await axios.get(`${BASE_URL}/api/export-attendance/${id}/`, {
          params: {
            start_date: startDate.toISOString().split("T")[0],
            end_date: endDate.toISOString().split("T")[0],
          },
          responseType: "blob",
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Attendance.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      toast.success("Export successful!");
      handleClose();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      } 
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Download Attendence Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3} className="text-center">
              Select Dates
            </Form.Label>
            <Col sm={9}>
              <Row>
                <Col>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    className="form-control me-2"
                  />
                </Col>
                -
                <Col>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    className="form-control"
                  />
                </Col>
              </Row>
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleExport}
          disabled={exportLoading}
        >
          {exportLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faFileExcel} className="me-2" />
              Download Excel
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ExportModal;
